module.exports = __webpack_public_path__ + "img/728.47ce627c.png";